import React from 'react';
import { PagesCardList } from 'components/organisms';
import articleImg from 'assets/imgs/template-article.jpg';

// todo templates query
const dummyTemplates = [
  {
    title: 'Article',
    description: 'For long texts and articles',
    img: articleImg,
    key: 1,
  },
  {
    title: 'From scratch',
    description: 'Start a new page without a template',
    icon: 'page',
    key: 2,
  },
];
const PagesUserList = () => <PagesCardList pages={dummyTemplates} />;

export default PagesUserList;
